import {useEffect} from "react";

export const APP_TITLE = "DIB";

export const withAppTitle = (name: string) => `${name} - ${APP_TITLE}`;

/**
 * Sets document.title to `<name> - DIB` while a named topic is displayed, and
 * falls back to `DIB` whenever the name is absent (e.g. the leaf's own data is
 * still loading). Content routes that mount no leaf are handled by ContentPage,
 * which resets the title to `DIB` for its loader/status/error states and on
 * unmount.
 */
export function useContentTitle(name: string | undefined, enabled = true) {
    useEffect(() => {
        if (!enabled) return;
        document.title = name ? withAppTitle(name) : APP_TITLE;
    }, [name, enabled]);
}
